import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

import enTranslation from '../locales/en/translation.json';
import roTranslation from '../locales/ro/translation.json';
import { DEFAULT_LANGUAGE } from './languages';

// #95: the app always starts in English; the entry language (URL, or the
// browser for the full-screen QR) is applied once by App through the language
// coordinator. No detector: a language cached in the browser storage by an
// older build never decides.
i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    debug: process.env.NODE_ENV === 'development',
    load: 'languageOnly',

    interpolation: {
      escapeValue: false,
    },

    pluralSeparator: '_',

    resources: {
      en: {
        translation: enTranslation,
      },
      ro: {
        translation: roTranslation,
      },
    },
    // #95: labels published without a language change (post-order refresh,
    // the shop English landing late) re-render the mounted components
    react: {
      bindI18nStore: 'added removed',
    },
    ns: ['translation', 'dynamic'],
    defaultNS: 'translation',
  });

export default i18n;
